/** @format */

/**
 * Подписи стадий сборки отчёта.
 *
 * API присылает коды, слова — наши: `COLLECTING` читателю ничего не
 * говорит, «Собираем данные» говорит всё. Тот же приём, что в самом
 * отчёте (`ExecutiveReport/content.ts`), только про сборку, а не про
 * содержание документа.
 *
 * Типы объявлены здесь, а не взяты из кодогена: сгенерированные enum'ы
 * живут в `__generated__`, который не коммитится, и словарь не должен от
 * него зависеть. Значения совпадают с `ProjectReportStatus` и
 * `ProjectReportErrorReason` из схемы.
 */

export type ReportStatus = 'PENDING' | 'COLLECTING' | 'GENERATING' | 'READY' | 'ERROR';

export type ReportErrorReason =
  | 'INTERNAL'
  | 'STATS_UNAVAILABLE'
  | 'MEDIAPLAN_NOT_FOUND'
  | 'KPI_NOT_SUPPORTED'
  | 'CHECKS_NEVER_COLLECTED';

/** Тон подписи: цвет чипа и текста статуса. */
export type StatusTone = 'good' | 'bad' | 'neutral';

export const STATUS_LABEL: Record<ReportStatus, string> = {
  PENDING: 'В\u00a0очереди',
  COLLECTING: 'Собираем данные',
  GENERATING: 'Готовим выводы',
  READY: 'Готов',
  ERROR: 'Не удалось\u00a0собрать',
};

export const ERROR_REASON_LABEL: Record<ReportErrorReason, string> = {
  INTERNAL: 'Непредвиденный сбой\u00a0сборки',
  STATS_UNAVAILABLE: 'Статистика кампаний\u00a0недоступна',
  MEDIAPLAN_NOT_FOUND: 'У\u00a0проекта нет\u00a0медиаплана',
  KPI_NOT_SUPPORTED: 'KPI медиаплана не\u00a0поддерживается',
  CHECKS_NEVER_COLLECTED: 'Проверки за\u00a0этот период не\u00a0собирались',
};

export function statusTone(status: ReportStatus): StatusTone {
  if (status === 'READY') return 'good';
  if (status === 'ERROR') return 'bad';
  return 'neutral';
}
